import { configureStore } from "@reduxjs/toolkit";

import { setupListeners } from "@reduxjs/toolkit/query";
import { AuthApi } from "src/services/auth/auth";
import { AuthSlice } from "src/services/auth/authSlice";
import { OrdersApi } from "src/services/orders/orders";
import { OrdersSlice } from "src/services/orders/ordersSlice";
import { NotificationApi } from "src/services/notification/notification";
import { NotificationSlice } from "src/services/notification/notificationSlice";
import { UserApi } from "src/services/user/user";
import { UserSlice } from "src/services/user/userSlice";
import { OrganisationApi } from "src/services/organisation/organisation";
import { OraganisationSlice } from "src/services/organisation/organisationSlice";
import { InventoryApi } from "src/services/inventory/inventory";
import { MapsApi } from "src/services/maps/map";
import { MapSlice } from "src/services/maps/mapSlice";
import {TransporterDriverSlice} from "src/services/transporterDrivers/transporterDriverSlice";
import { TransportDriverApi } from "src/services/transporterDrivers/transporterDrivers";
import {TransporterVehiclesSlice} from "src/services/transporterVehicles/transporterVehicleSlice";
import { TransportVehicleApi } from "src/services/transporterVehicles/transporterVehicles";
import {StationSlice} from "src/services/station/stationSlice";
import { StationApi } from "src/services/station/station";
import { DashboardApi } from "src/services/dashboard/dashboard";
import { PaymentApi } from "src/services/payment/orderPayment";

export const store = configureStore({
  reducer: {
    [AuthApi.reducerPath]: AuthApi.reducer,
    [AuthSlice.name]: AuthSlice.reducer,
    [UserApi.reducerPath]: UserApi.reducer,
    [UserSlice.name]: UserSlice.reducer,
    [OrdersApi.reducerPath]: OrdersApi.reducer,
    [OrdersSlice.name]: OrdersSlice.reducer,
    [OrganisationApi.reducerPath]: OrganisationApi.reducer,
    [OraganisationSlice.name]: OraganisationSlice.reducer,
    [InventoryApi.reducerPath]: InventoryApi.reducer,
    [NotificationApi.reducerPath]: NotificationApi.reducer,
    [NotificationSlice.name]: NotificationSlice.reducer,
    [MapsApi.reducerPath]: MapsApi.reducer,
    [MapSlice.name]: MapSlice.reducer,
    [TransportDriverApi.reducerPath]: TransportDriverApi.reducer,
    [TransporterDriverSlice.name]: TransporterDriverSlice.reducer,
    [TransportVehicleApi.reducerPath]: TransportVehicleApi.reducer,
    [TransporterVehiclesSlice.name]: TransporterVehiclesSlice.reducer,
    [StationSlice.name]:StationSlice.reducer,
    [StationApi.reducerPath]:StationApi.reducer,
    [DashboardApi.reducerPath]: DashboardApi.reducer,
    [PaymentApi.reducerPath]: PaymentApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      AuthApi.middleware,
      UserApi.middleware,
      OrdersApi.middleware,
      OrganisationApi.middleware,
      InventoryApi.middleware,
      NotificationApi.middleware,
      MapsApi.middleware,
      TransportDriverApi.middleware,
      TransportVehicleApi.middleware,
      StationApi.middleware,
      PaymentApi.middleware,
      DashboardApi.middleware,
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
